import attendApi from '~cfg/router/nrw/api/attendApi.js'
import commonApi from '~cfg/router/nrw/api/commonApi.js'
import homeApi from '~cfg/router/nrw/api/homeApi.js'
import mySpaceApi from '~cfg/router/nrw/api/mySpaceApi.js'
import courseApi from '~cfg/router/nrw/api/courseApi.js'
import boardApi from '~cfg/router/nrw/api/boardApi.js'
import searchApi from '~cfg/router/nrw/api/searchApi.js'
import lrningApi from '~cfg/router/nrw/api/lrningApi.js'
import enrolmentApi from '~cfg/router/nrw/api/enrolmentApi.js'
import myInfoApi from '~cfg/router/nrw/api/myInfoApi.js'
import myQestnApi from '~cfg/router/nrw/api/myQestnApi.js'
import custCntrApi from '~cfg/router/nrw/api/custCntrApi.js'
import choiceApi from '~cfg/router/nrw/api/choiceApi.js'
import memberApi from '~cfg/router/nrw/api/memberApi.js'
import couponApi from '~cfg/router/nrw/api/couponApi.js'
import dashBoard from '~cfg/router/nrw/api/dashBoard.js'

export default {
  ...attendApi,
  ...commonApi,
  ...homeApi,
  ...mySpaceApi,
  ...courseApi,
  ...boardApi,
  ...searchApi,
  ...lrningApi,
  ...enrolmentApi,
  ...myInfoApi,
  ...myQestnApi,
  ...custCntrApi,
  ...choiceApi,
  ...memberApi,
  ...couponApi,
  ...dashBoard
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/apiMain.js